<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 960">
    <title>Vai</title>
    <path
      d="M272.827 722.242c-9.282 0-18.053-3.585-24.697-10.095-6.687-6.574-10.411-15.381-10.5-24.813-.067-9.432 3.508-18.296 10.067-24.987l349.274-353.713H414.822c-19.533 0-35.423-15.898-35.423-35.438s15.891-35.438 35.423-35.438h272.11c19.541 0 35.439 15.898 35.439 35.438v264.87c0 19.54-15.898 35.438-35.439 35.438s-35.468-15.898-35.468-35.438V353.642L297.989 711.653c-6.685 6.82-15.631 10.59-25.162 10.59z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
